// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeStripsStripCopyUsersBody = {
  poolId: string;
  eventId: string;
  stripNumber: number;
  fromStripNumber: number;
};

export type typeStripsStripCopyUsersOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { stripNumber: number; changedRowCount: number };
};

export type typeStripsStripCopyUsersOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsStripCopyUsersOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsStripCopyUsersOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaStripsStripCopyUsersBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    eventId: { type: "string", maxLength: 3000, minLength: 1 },
    stripNumber: { type: "integer" },
    fromStripNumber: { type: "integer" },
  },
  required: ["poolId", "eventId", "stripNumber", "fromStripNumber"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createStripsStripCopyUsers(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaStripsStripCopyUsersBody);
  }

  return async function postStripsStripCopyUsers(
    payload: typeStripsStripCopyUsersBody,
  ): Promise<
    typeStripsStripCopyUsersOutput200 | typeStripsStripCopyUsersOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postStripsStripCopyUsers" failed before calling the network. #86cfb84e7cc7`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#86cfb84e7cc7" },
        },
        data: null,
      } as typeStripsStripCopyUsersOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/strips/strip-copy-users`,
      httpMethod: "POST",
      options,
    })) as
      typeStripsStripCopyUsersOutput200 | typeStripsStripCopyUsersOutput400;
  };
}
